import type { ComputedRef, Ref } from 'vue'
import { nextTick, watch } from 'vue'
export function useResizableTextarea(
  textareaRef: Ref<HTMLTextAreaElement | undefined>,
  value: ComputedRef<string | number>,
  options = {
    minHeight: 32,
    scrollMargin: 0,
  },
) {
  const resizeTextarea = (): void => {
    if (!textareaRef.value) return

    textareaRef.value.style.height = `${options.minHeight}px`
    textareaRef.value.style.height = `${Math.max(
      textareaRef.value.scrollHeight + options.scrollMargin,
      options.minHeight,
    )}px`
  }

  watch(
    () => value.value,
    () => {
      nextTick(() => {
        resizeTextarea()
      })
    },
  )

  return {
    resizeTextarea,
  }
}
